const DownloadIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 16 16' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 13 7 L 12.3 6.3 L 8.5 10.1 V 1 H 7.5 V 10.1 L 3.7 6.3 L 3 7 L 8 12 L 13 7 Z M 13 12 V 14 H 3 V 12 H 2 V 14 C 2 14.6 2.4 15 3 15 H 13 C 13.6 15 14 14.6 14 14 V 12 H 13 Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default DownloadIcon;
